<!-- ToggleCard.vue -->
<template>
    <CCard class="p-3 mt-3 bg-F9FAFB border-16px" style="border:none">
      <CRow style="text-align: left;">
        <CCol style="text-align: left;" sm="12" lg="12" @click="toggle">
          <div style="text-align: left" class="item-text">
            <CRow>
              <CCol sm="11">
                <h4 class="custom-18px-500 font-color-101828">{{ title }}</h4>
              </CCol>
              <!-- <CCol sm="1" style="color:#171717">{{ isActive ? '-' : '+' }}</CCol> -->
              <CCol sm="1" style="color:#171717">
  <img v-if="isActive" src="../assets/image/minus-circle.png" alt="Minus" width="20px" />
  <img v-else src="../assets/image/plus-circle.png" alt="Plus" width="20px" />
</CCol>

            </CRow>
          </div>
        </CCol>
  
        <CCol sm="12" lg="12">
          <div v-show="isActive" class="item-desc font-color-98A2B3">
            <slot class="custom-16px-400 font-color-98A2B3"></slot>
          </div>
        </CCol>
      </CRow>
    </CCard>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isActive: false,
      };
    },
    props: {
      title: String,
    },
    methods: {
      toggle() {
        this.isActive = !this.isActive;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add any specific styles for your ToggleCard component */
 
  </style>
  